

import React, { useEffect, useState } from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import { useParams } from "react-router-dom";
import HomeDetailComponent from './HomeDetailComponent';
import HomeCheckListComponent from './HomeCheckListComponent';
import StaffComponent from './StaffComponent';
import HomeAuditReportManagement from '../AuditReportManagement/HomeAuditReportManagement';
import * as apiUtility from "../../config/APIUtils";
import HomeAdminPermissions from '../AdminPermissions_Component/HomeAdminPermissions';
import OrgPolicyComponent from './OrgPolicyComponent';
import TrainStandardComponent from "./TrainStandardComponent";


function OrgCheckListAndPolicyComponent(props) {
    console.log("IN OrgCheckListAndPolicyComponent")
    const [homes_list, setHomesList] = useState([]);

    const [user_ID, setUser_ID] = useState(-1);
    
    var propsId = props.homeIdFprAdmin
    var params = propsId;
    if (props.id) {
        params = props.id
    }
    //console.log("Props here---------",props)

    var user_id = useParams().id;
    var propsId2 = props.userId;
    var userID = propsId2;
    if (!userID) {
        userID = user_id;
    }
    // if (!propsId) {

    //     params = paramId;

    // }
    useEffect(async () => {
        console.log("props------------>",props)
        setUser_ID(userID);
        if (props.homeIdFprAdmin) {
            params = props.homeIdFprAdmin
        }
        var orgProps;
        if (props.orgId) {
            orgProps = props.orgId
        }

        if(orgProps == undefined && params != undefined){
            //When ORG ID is not present just search with Home ID
            var apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "orgnization/getHomeDetails/" + params;
            await apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
                setHomesList(res.data)
            }).catch((error) => {
                console.error(error);
                // setshowSpinner(false);
            });

        }else{
            //When ORG ID is present, then search for all Home.
            const BASE_URL_GET_All_HOMELIST = "orgnization/getHomesList/" + orgProps;
            var apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = BASE_URL_GET_All_HOMELIST;
            await apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
                setHomesList(res.data)
            }).catch((error) => {
                console.error(error);
            });
        }

        
    }, [props.homeIdFprAdmin])

    

    return (
        <div>

            <Tabs defaultActiveKey="trainStandard" fill style={{ display: "flex", marginTop: "5%" }}>
                
                 <Tab eventKey="trainStandard" title="Training Standard">
                    <TrainStandardComponent id={params} />
    
                    </Tab> 

                <Tab eventKey="OrgPolicyComponent" title="Manage Org Docs">
                    <OrgPolicyComponent id={params} />
                </Tab>
               
            </Tabs>

        </div>
    )
}

export default OrgCheckListAndPolicyComponent